import { desktopVmOptions } from "../../../../../Components/common/SubmitPopup/constants";

// The pages in the left rail and the backend submit type each one configures.
// Adding one here is enough, as long as the backend knows the submit type.
export const AUTO_SUBMISSION_PAGES = [
  { label: "API & UI", submitType: "api_ui" },
  { label: "Mail Gateway", submitType: "mail_gateway" },
  { label: "Web", submitType: "web" },
];

// At most this many operating systems can be configured per submit type
// (mirrors AUTO_SUBMISSION_MAX_OS on the backend).
export const AUTO_SUBMISSION_MAX_OS = 2;

// Machine id -> label, reusing the SubmitPopup catalogue so the names stay in sync
// (note linux22/macos16 are labelled "Linux"/"MacOS", which is what Content checks to hide the Type field).
export const AUTO_SUBMISSION_OS_CATALOG = desktopVmOptions.map(({ id, name }) => ({ id, name }));

export const getOsName = (id) => AUTO_SUBMISSION_OS_CATALOG.find((os) => os.id === id)?.name || id;

// /submitpopup/vms reports every running machine; auto submission only supports the ones
// in the catalogue (android is not one of them).
export const getAvailableOs = (vms) =>
  (vms || []).filter((id) => AUTO_SUBMISSION_OS_CATALOG.some((os) => os.id === id));

// Expose every configurable field of the SubmitPopup Content component.
export const AUTO_SUBMISSION_CONTENT_SHOW = {
  type: true,
  commandLine: true,
  enviromentalVariable: true,
  relatedPasswords: true,
  runtimeDuration: true,
  actionScript: true,
  enforceRuntime: true,
  artifactAnalysis: true,
  networkTraffic: true,
};

// Fallback values (backend single-value shape) used until settings are fetched.
export const defaultOsSettings = {
  enabled: false,
  type: "full_triage",
  network_traffic: "vpn",
  command_line: "",
  enviromental_variable: "",
  related_password: "",
  runtime_duration: 120,
  enforse_runtime: true,
  enforse_submission: false,
  memory_dump: "advanced",
  action_script: "default",
};
